/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vs-logs';
const componentName = 'vs-logs-significance-options';
const prefix = `${moduleName}.${componentName}`;

export const nonSignificantLabel = `${prefix}.nonSignificantLabel`;
export const significantLabel = `${prefix}.significantLabel`;
export const enableNonSignificantLogsMessage = `${prefix}.enableNonSignificantLogsMessage`;

export const ENGLISH = {
    [nonSignificantLabel]: 'Non-Significant',
    [significantLabel]: 'Significant',
    [enableNonSignificantLogsMessage]: 'Non-significant logs are now turned off. To activate them, go to Virtual Service Settings → Analytics and select Enable Non-Significant Logs.',
};
